import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect, ReactNode } from "react";
import { useWidgetSelector } from "../store/store";
import { State } from "../store/state";
import AnimateHeight from "react-animate-height";
interface ICarouselProps {
  children: React.ReactNode[];
  minHeight: number;
  inline?: boolean;
}
function smoothScrollTo(element: any, to: number, duration: number) {
  const start = element.scrollTop;
  const change = to - start;
  const startTime = performance.now();
  function animate(currentTime: number) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // Easing function (ease-in-out)
    const easeProgress = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
    element.scrollTop = start + change * easeProgress;
    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }
  requestAnimationFrame(animate);
}
export const Carousel: React.FC<ICarouselProps> = t0 => {
  const $ = _c(30);
  const {
    children,
    minHeight,
    inline
  } = t0;
  const carouselRef = useRef(null);
  const [currentPaneNumber, setCurrentPaneNumber] = useState(0);
  const storePaneNumber = useWidgetSelector(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [renderedPanes, setRenderedPanes] = useState(t1);
  const [temporaryHeight, setTemporaryHeight] = useState(null);
  const currentPaneNumberRef = useRef(currentPaneNumber);
  let t2;
  let t3;
  if ($[1] !== currentPaneNumber) {
    t2 = () => {
      currentPaneNumberRef.current = currentPaneNumber;
    };
    t3 = [currentPaneNumber];
    $[1] = currentPaneNumber;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== currentPaneNumber || $[5] !== inline) {
    t4 = offset => {
      const previousPaneNumber = currentPaneNumber;
      const nextPaneNumber = currentPaneNumber + offset;
      setRenderedPanes(current => {
        const updated = [...current];
        updated[nextPaneNumber] = 1;
        return updated;
      });
      setCurrentPaneNumber(nextPaneNumber);
      if (carouselRef.current?.parentElement) {
        if (inline) {
          window.scrollTo({
            top: carouselRef.current.parentElement.offsetTop,
            behavior: "smooth"
          });
        } else {
          smoothScrollTo(carouselRef.current.parentElement, 0, 200);
        }
      }
      setTimeout(() => {
        const currentHeight = carouselRef.current?.clientHeight;
        setTemporaryHeight(currentHeight || null);
      }, 1);
      setTimeout(() => {
        setRenderedPanes(current_0 => {
          if (currentPaneNumberRef.current === previousPaneNumber) {
            return current_0;
          }
          const updated_0 = [...current_0];
          updated_0[previousPaneNumber] = 0;
          return updated_0;
        });
        setTemporaryHeight(null);
      }, 200);
    };
    $[4] = currentPaneNumber;
    $[5] = inline;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const changePaneByOffset = t4;
  let t5;
  if ($[7] !== changePaneByOffset || $[8] !== currentPaneNumber || $[9] !== storePaneNumber) {
    t5 = () => {
      if (storePaneNumber > currentPaneNumber) {
        changePaneByOffset(1);
      } else {
        if (storePaneNumber < currentPaneNumber) {
          changePaneByOffset(-1);
        }
      }
    };
    $[7] = changePaneByOffset;
    $[8] = currentPaneNumber;
    $[9] = storePaneNumber;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== storePaneNumber) {
    t6 = [storePaneNumber];
    $[11] = storePaneNumber;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
  const t7 = `${minHeight}px`;
  let t8;
  if ($[13] !== t7) {
    t8 = {
      minHeight: t7
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = temporaryHeight ? temporaryHeight : "auto";
  const t10 = `translate3d(${currentPaneNumber * -100}%, 0px, 0px)`;
  let t11;
  if ($[15] !== t10) {
    t11 = {
      transform: t10
    };
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== children || $[18] !== currentPaneNumber || $[19] !== renderedPanes) {
    t12 = children && children.filter(_temp2).map((child_0, i) => <div className="pane" key={i}>{(renderedPanes[i] === 1 || i === currentPaneNumber) && child_0}</div>);
    $[17] = children;
    $[18] = currentPaneNumber;
    $[19] = renderedPanes;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className="carousel" style={t11}>{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t9) {
    t14 = <AnimateHeight height={t9} duration={200}>{t13}</AnimateHeight>;
    $[24] = t13;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t8) {
    t15 = <div className="carousel-wrapper" style={t8} ref={carouselRef}>{t14}</div>;
    $[27] = t14;
    $[28] = t8;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
function _temp(state) {
  return state.layout.paneNumber;
}
function _temp2(child) {
  return child !== false;
}